module.exports = __webpack_public_path__ + "static/media/sermsang-solution.427e75dc.png";